import { Component, Input, OnDestroy, inject } from '@angular/core';
import { SubSink } from 'subsink';
import { SearchResult, StateService } from '..';
import { LogService } from 'src/app/my-sedgwick';

@Component({
    selector: 'app-base',
    template: ` <p>base works!</p> `,
    styles: [],
    standalone: false
})
export class BaseComponent implements OnDestroy {
  subs = new SubSink();

  @Input()
  tag: string;

  public state = inject(StateService);
  public logService1 = inject(LogService);

  constructor() {}

  scrollIntoView(elementId: string) {
    const el = document.getElementById(elementId);
    if (!el) {
      return;
    }

    const rect = el.getBoundingClientRect();
    const y = el.getBoundingClientRect().top + window.pageYOffset - 80;
    const isVisible = this.isElementInViewport(rect);
    if (!isVisible) {
      document.querySelector('.mat-sidenav-content').scrollTo({
        top: y,
        behavior: 'smooth',
      });
    }
  }

  private isElementInViewport(rect: DOMRect) {
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.top + 100 <=
        (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  /* fatureName  = Feature saved in Feature_name
     linkArea + - tabName saved in section */
  FeatureLogging(featureName: string, tabName: string, linkArea: string) {
    this.LogFeature1(featureName, tabName, linkArea, undefined);
  }

  FeatureLoggingWithClaim(
    featureName: string,
    tabName: string,
    linkArea: string,
    claim: SearchResult
  ) {
    this.LogFeature1(featureName, tabName, linkArea, claim);
  }

  LogFeature1(
    featureName: string,
    tabName: string,
    linkArea: string,
    claim: SearchResult,
    dcoumentId: string = ''
  ) {
    let linkSection = linkArea;
    linkSection =
      tabName === '' || tabName === undefined || tabName === null
        ? linkSection
        : linkSection + ' - ' + tabName;
    this.logService1.LogFeature(claim, featureName, linkSection, dcoumentId);
  }

  FeatureLoggingWithClaimDocumentID(
    featureName: string,
    tabName: string,
    linkArea: string,
    claim: SearchResult,
    dcoumentId: string
  ) {
    /*    claim: SearchResult,
    FeatureName: string,
    SectionName: string,
    DocumentId: string = '' */
    this.LogFeature1(featureName, tabName, linkArea, claim, dcoumentId);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
